interface Props {
  title: string;
  imageUrl: string | null;
  bodyHtml: string;
  onClose: () => void;
}

// The body is "non-empty" when it has visible text OR an image — an image-only
// post must still preview, not fall back to the empty placeholder.
function hasContent(html: string): boolean {
  if (/<img\b/i.test(html)) return true;
  return html.replace(/<[^>]*>/g, '').trim().length > 0;
}

export default function PreviewPane({ title, imageUrl, bodyHtml, onClose }: Props) {
  return (
    <div className="hidden lg:flex lg:flex-col">
      <div className="sticky top-24 overflow-hidden rounded-xl border border-hairline bg-white">
        <div className="flex items-center justify-between px-5 pt-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-meta">
            Preview
          </span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Hide preview"
            className="-mr-1 inline-flex items-center gap-1.5 rounded-full px-3 py-1 font-trirong_reg
                       text-[13px] text-lime-700 transition-colors hover:bg-[#f1f4e1] focus:outline-none
                       focus:ring-2 focus:ring-lime-600/40"
          >
            <svg
              viewBox="0 0 16 16"
              aria-hidden="true"
              className="h-3.5 w-3.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            >
              <path d="M4 4l8 8M12 4l-8 8" />
            </svg>
            Hide preview
          </button>
        </div>
        {imageUrl && (
          <img src={imageUrl} alt="" className="mt-3 h-[170px] w-full object-cover" />
        )}
        <div className="px-6 pb-7 pt-5">
          <h1 className="mb-4 font-trirong_reg text-[27px] leading-tight text-gray-800">
            {title || 'Untitled blog'}
          </h1>
          {hasContent(bodyHtml) ? (
            <div
              className="prose prose-sm max-w-none font-trirong_light text-gray-800
                         prose-headings:font-trirong_reg prose-headings:text-gray-800
                         prose-blockquote:border-l-[#9db39f] prose-a:text-lime-700"
              dangerouslySetInnerHTML={{ __html: bodyHtml }}
            />
          ) : (
            <p className="font-trirong_light italic text-[#aeb59a]">
              Your words will appear here as you write.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
